import { gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { serviceOrdersClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useStatusesState = () => React.useContext(Context) || {}
export const useStatuses = () => useStatusesState()?.statuses || []
export const useTranslatedStatuses = () => {
  const { t } = useTranslation()
  const statuses = useStatuses()
  return statuses.map(status => ({ ...status, label: t('status.' + status.name) }))
}

const QUERY = gql`
  query Statuses($page: Int, $limit: Int, $search: String) {
    statuses(page: $page, limit: $limit, search: $search, sort: { field: ID, type: ASC }) {
      id
      name
    }
  }
`

const StatusesLoader = ({ children, search, filter, perPage: limit, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search
    },
    fetchPolicy: 'cache-first',
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default StatusesLoader
